
import { set, toggle } from '@/utils/vuex'
import { getList as getProtocols } from '@/api/protocol'
import { getListUnread as getSponsors } from '@/api/sponsor'
import Cookies from 'js-cookie'
import { normalizeFilters } from '../../utils/filters'
import { getConfig } from '@/api/user'

const state = {
  loading: false,
  drawer: null,
  color: 'success',
  image: '',
  sidebarBackgroundColor: 'rgba(27, 27, 27, 0.84)',
  snackbar: {},

  sponsor_dialog: false,
  protocol_dialog: false,
  protocol_item: {},
  site_dialog: false,
  site_item: {},
  protocol_site_dialog: false,
  protocol_site_item: {},
  treatment_dialog: false,
  treatment_item: {},
  external_user_dialog: false,
  external_user_item: {},
  adverse_event_dialog: false,
  adverse_event_mandatory_dialog: false,
  adverse_event_item: {},
  pregnancy_dialog: false,
  pregnancy_item: {},
  som_dialog: false,
  spm_item: {},

  protocols: [],
  sponsors: [],
  sponsor_id: null,
  treatments: [],
  sites: [],
  external_users: [],
  sponsorsDisabled: false,
  config: {},
  //issue 679
  changePassword: {},
  //issue 679
  isShowClosedProtocol:null
}

const mutations = {
  loading: set('loading'),
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
  snackbar: set('snackbar'),

  sponsorDialog: set('sponsor_dialog'),
  protocolDialog: set('protocol_dialog'),
  protocolItem: set('protocol_item'),
  siteDialog: set('site_dialog'),
  siteItem: set('site_item'),
  protocolSiteDialog: set('protocol_site_dialog'),
  protocolSiteItem: set('protocol_site_item'),
  treatmentDialog: set('treatment_dialog'),
  treatmentItem: set('treatment_item'),
  externalUserDialog: set('external_user_dialog'),
  externalUserItem: set('external_user_item'),
  adverseEventDialog: set('adverse_event_dialog'),
  adverseEventMandatoryDialog: set('adverse_event_mandatory_dialog'),
  adverseEventItem: set('adverse_event_item'),
  pregnancyDialog: set('pregnancy_dialog'),
  pregnancyItem: set('pregnancy_item'),
  spmDialog: set('spm_dialog'),
  spmItem: set('spm_item'),

  protocols: set('protocols'),
  sponsors: set('sponsors'),
  sponsor_id: set('sponsor_id'),
  treatments: set('treatments'),
  sites: set('sites'),
  external_users: set('external_users'),
  sponsorsDisabled: set('sponsorsDisabled'),
  isShowClosedProtocol:set('isShowClosedProtocol'),
  SET_CONFIG: (state, v) => {
    state.config = v
  },

  //issue 679
  changePassword: set('changePassword')
  //issue 679
}

const actions = {
  startLoading: (context, payload = {}) => {
    context.commit('loading', true)
  },
  stopLoading: (context, payload = {}) => {
    context.commit('loading', false)
  },
  openSponsorDialog: (context, payload = {}) => {
    context.commit('protocolDialog', true)
  },
  closeSponsorDialog: (context, payload = {}) => {
    context.commit('protocolDialog', false)
  },
  openProtocolDialog: (context, payload = {}) => {
    context.commit('protocolItem', payload) // THIS ORDER IS IMPORTANT!!!
    context.commit('protocolDialog', true) // THIS ORDER IS IMPORTANT!!!
  },
  closeProtocolDialog: context => {
    context.commit('protocolDialog', false)
    //context.commit('variableItem', {})
  },
  openSiteDialog: (context, payload = {}) => {
    context.commit('siteItem', payload) // THIS ORDER IS IMPORTANT!!!
    context.commit('siteDialog', true) // THIS ORDER IS IMPORTANT!!!
  },
  closeSiteDialog: context => {
    context.commit('siteDialog', false)
    //context.commit('timepointItem', {})
  },
  openProtocolSiteDialog: (context, payload = {}) => {
    context.commit('protocolSiteItem', payload) // THIS ORDER IS IMPORTANT!!!
    context.commit('protocolSiteDialog', true) // THIS ORDER IS IMPORTANT!!!
  },
  closeProtocolSiteDialog: context => {
    context.commit('protocolSiteDialog', false)
    //context.commit('timepointItem', {})
  },
  openTreatmentDialog: (context, payload = {}) => {
    context.commit('treatmentItem', payload)
    context.commit('treatmentDialog', true)
  },
  closeTreatmentDialog: (context, payload = {}) => {
    context.commit('treatmentDialog', false)
  },
  openExternalUserDialog: (context, payload = {}) => {
    context.commit('externalUserItem', payload)
    context.commit('externalUserDialog', true)
  },
  closeExternalUserDialog: (context, payload = {}) => {
    context.commit('externalUserDialog', false)
  },
  openAdverseEventDialog: (context, payload = {}) => {
    context.commit('adverseEventItem', payload)
    context.commit('adverseEventDialog', true)
  },
  closeAdverseEventDialog: (context, payload = {}) => {
    context.commit('adverseEventDialog', false)
  },
  openAdverseEventMandatoryDialog: (context, payload = {}) => {
    context.commit('adverseEventItem', payload)
    context.commit('adverseEventMandatoryDialog', true)
  },
  closeAdverseEventMandatoryDialog: (context, payload = {}) => {
    context.commit('adverseEventMandatoryDialog', false)
  },
  openPregnancyDialog: (context, payload = {}) => {
    context.commit('pregnancyItem', payload)
    context.commit('pregnancyDialog', true)
  },
  closePregnancyDialog: (context, payload = {}) => {
    context.commit('pregnancyDialog', false)
  },
  openSnackbar: (context, payload) => {
    payload['active'] = true
    context.commit('snackbar', payload)
  },
  closeSnackbar: context => {
    context.commit('snackbar', {active: false})
  },
  loadProtocols: async (context, payload) => {
    const sponsor_id = Cookies.get('choosed_sponsor')
    const is_show_closed_protocol = parseInt(Cookies.get('is_show_closed_protocol'))
    let protocolFilter={sponsor_id,"protocol.status": ['Open','Draft']}
      if(is_show_closed_protocol){
        protocolFilter={sponsor_id: payload,"protocol.status": ['Open','Draft','Closed']}
      }else{
        protocolFilter={sponsor_id: payload,"protocol.status": ['Open','Draft']}
      }
    getProtocols({protocolFilter}, {rowsPerPage: null, sortBy:'name', descending:false}).then(data => {
      context.commit('protocols', data.data)
    })
  },
  loadSponsors: async (context, payload) => {
    return getSponsors(null, {rowsPerPage: null}).then(data => {
      context.commit('sponsors', data.data)
      const sponsors = data.data;
      const defaultSponsor = sponsors[0]['id'];
      const choosedSponsor = parseInt(Cookies.get('choosed_sponsor'))
      context.dispatch("setSponsor", choosedSponsor || defaultSponsor)
      return data.data
    })
  },
  setSponsor: async (context, payload) => {
    Cookies.set('choosed_sponsor', payload)
    context.commit('sponsor_id', payload)
    
    const is_show_closed_protocol = parseInt(Cookies.get('is_show_closed_protocol'))
    let protocolFilter={sponsor_id: payload,"protocol.status": ['Open','Draft']}
      if(is_show_closed_protocol){
        protocolFilter={sponsor_id: payload,"protocol.status": ['Open','Draft','Closed']}
      }else{
        protocolFilter={sponsor_id: payload,"protocol.status": ['Open','Draft']}
      }
    getProtocols({protocolFilter}, {rowsPerPage: null, sortBy:'name', descending:false}).then(data => {
      context.commit('protocols', data.data)
    })
  },
  setIsShowClosedProtocol: (context, payload) => {
    Cookies.set('is_show_closed_protocol', payload)
    context.commit('isShowClosedProtocol', payload)
    const choosedSponsor = parseInt(Cookies.get('choosed_sponsor'))
    const is_show_closed_protocol = parseInt(Cookies.get('is_show_closed_protocol'))
    let protocolFilter={sponsor_id: choosedSponsor,"protocol.status": ['Open','Draft']}
      if(is_show_closed_protocol){
        protocolFilter={sponsor_id: choosedSponsor,"protocol.status": ['Open','Draft','Closed']}
      }else{
        protocolFilter={sponsor_id: choosedSponsor,"protocol.status": ['Open','Draft']}
      }
    getProtocols({protocolFilter}, {rowsPerPage: null, sortBy:'name', descending:false}).then(data => {
      context.commit('protocols', data.data)      
    })
  },
  sponsorsDisabled: (context, payload)  => {
    context.commit('sponsorsDisabled', payload)
  },

  async getConfig({ commit }) {
    commit('SET_CONFIG', await getConfig())
  },

  openChangePassword: (context, payload) => {
    payload['active'] = true
    //issue 679
    context.commit('changePassword', payload)
    //issue 679
  },
  closeChangePassword: context => {
    //issue 679
    context.commit('changePassword', {active: false})
    //issue 679
  },
  
}

// const getters = {
//   variableDialog: state => {
//     return state.variable_dialog
//   },
//   variableItem: state => {
//     return state.variable_item
//   }
// }

export default {
  // getters
  namespaced: true,
  state,
  mutations,
  actions
}
